import * as React from "react";

export class RefreshButton extends React.Component<{ refreshing: boolean, onClick: () => void }, {}> {
    render() {
        return (
            <span className={'pull-right ' + (this.props.refreshing ? "rotate-icon" : "")}>
                <span className="fa fa-rotate-right fa-2x" onClick={this.props.onClick}></span>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/util/RefreshButton.tsx